(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tq-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  document.querySelectorAll('.tq-menu[open]').forEach(menu => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.tq-menu[open]').forEach(menu => {
    const focusWasInside = menu.contains(document.activeElement);
    menu.open = false;
    if (focusWasInside) menu.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-back-to-top"]) return;
  try {
    
if(!customElements.get('brovale-back-to-top')){
  customElements.define('brovale-back-to-top',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();
      this.abort=new AbortController();
      this.button=this.querySelector('button');
      if(!this.button)return;
      this.mobile=window.matchMedia('(max-width:749px)');
      const options={signal:this.abort.signal};
      const update=()=>{this.button.hidden=!this.mobile.matches||window.scrollY<600};
      const schedule=()=>{
        if(this.frame)return;
        this.frame=window.requestAnimationFrame(()=>{this.frame=0;update()});
      };
      window.addEventListener('scroll',schedule,{...options,passive:true});
      window.addEventListener('pageshow',update,options);
      this.mobile.addEventListener('change',update,options);
      this.button.addEventListener('click',()=>{
        const main=document.getElementById('MainContent');
        main?.focus({preventScroll:true});
        window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      },options);
      update();
    }
    disconnectedCallback(){this.abort?.abort();window.cancelAnimationFrame(this.frame)}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const link=event.target.closest('[data-ts-sort-value]');
  if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  event.preventDefault();
  const url=new URL(window.location.href);
  url.searchParams.set('sort_by',link.dataset.tsSortValue);
  url.searchParams.delete('page');
  window.location.assign(url.href);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-contact-intro"]) return;
  try {
    
function initBrovaleContact(){const intro=document.querySelector('[data-ts-contact-prefix]');const field=document.querySelector('textarea[name="contact[body]"]');const product=new URLSearchParams(window.location.search).get('product');if(intro&&field&&!field.value&&product){field.value=intro.dataset.tsContactPrefix+' '+product+'\n\n';}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBrovaleContact,{once:true});else initBrovaleContact();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-toy-finder"] && !Shopify.designMode) return;
  try {
    
function setupToyFinders(root=document){root.querySelectorAll('[data-toy-finder]').forEach(finder=>{if(finder.dataset.ready)return;finder.dataset.ready='true';const category=finder.querySelector('[data-finder-category]');const budget=finder.querySelector('[data-finder-budget]');const items=[...finder.querySelectorAll('[data-finder-item]')];const more=finder.querySelector('[data-finder-more]');let expanded=false;function update(){const matches=items.filter(item=>(category.value==='all'||item.dataset.categories.split(' ').includes(category.value))&&(budget.value==='all'||Number(item.dataset.price)<Number(budget.value)));items.forEach(item=>item.hidden=true);matches.slice(0,expanded?matches.length:4).forEach(item=>item.hidden=false);finder.querySelector('[data-finder-count]').textContent=matches.length+' '+finder.querySelector('[data-count-label]').textContent;finder.querySelector('[data-finder-empty]').hidden=matches.length>0;more.hidden=expanded||matches.length<=4;}[category,budget].forEach(select=>select.addEventListener('change',()=>{expanded=false;update();}));more.addEventListener('click',()=>{expanded=true;update();});update();});}setupToyFinders();document.addEventListener('shopify:section:load',()=>setupToyFinders());

  } catch(e) { console.error(e); }
})();
})();
